module.exports = __webpack_public_path__ + "img/image_03.f7346b8f.png";